export function isHexaColor(value: string) {
  const hexaRegex = /^#([A-Fa-f0-9]{4}|[A-Fa-f0-9]{8})$/;
  return hexaRegex.test(value);
}
